<template>
    <div>
        <DesktopQuestion v-if="!isMobile" />
        <MobileQuestion v-else />
    </div>
</template>

<script>
import DesktopQuestion from '@/components/Question/Desktop/Question'
import MobileQuestion from '@/components/Question/Mobile/Question'
export default {
  components: {
    DesktopQuestion,
    MobileQuestion
  },
  data() {
    return{
      isMobile: false
    }
  },
  methods: {
      handleView() {
          this.isMobile = screen.width <= 990
      }
  },
  beforeMount() {
    this.handleView()
    this.$gtag.pageview(this.$route)
  }
}
</script>